import { FaCloudMoon, FaSearch, FaSun } from "react-icons/fa";
import Sidebar from "./Sidebar";
import { IoSettingsOutline } from "react-icons/io5";
import { FaLocationDot } from "react-icons/fa6";
import { BsTranslate } from "react-icons/bs";
import { FiCoffee } from "react-icons/fi";
import { MdCurrencyExchange } from "react-icons/md";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { IoIosWarning } from "react-icons/io";

export default function Dashboard() {

    const [search, setsearch] = useState("");

    const cardsss = [
        { link: "/Location", icon: <FaLocationDot />, name: "Location", desc: "Detect and explore your current location." },
        { link: "/Translator", icon: <BsTranslate />, name: "AI Translator", desc: "Translate text to any language instantly." },
        { link: "/NearMe", icon: <FaSearch />, name: "Near Me", desc: "Find places, ATM's, Cafes nearby." },
        { link: "/Foodapps", icon: <FiCoffee />, name: "Food Apps", desc: "Discover food delivery apps by region." },
        { link: "/Currency", icon: <MdCurrencyExchange />, name: "Currency", desc: "Convert currencies with live rates." },
        { link: "/Emergency", icon: <IoIosWarning />, name: "Emergency", desc: "Access local emergency numbers and essential help services instantly." },
    ];

    const filteredcards = cardsss.filter((card) =>
        card.name.toLowerCase().includes(search.toLowerCase())
    );

    const [location, setlocation] = useState("Detecting location...");
    const [error, seterror] = useState("");
    const [temp, setTemp] = useState("--");
    const [weather, setWeather] = useState("Loading...");
    const [weatherIcon, setWeatherIcon] = useState("cloud");

    const [theme, setTheme] = useState(localStorage.getItem("theme") || "dark");

    useEffect(() => {
        const savedTheme = localStorage.getItem("theme") || "dark";
        setTheme(savedTheme);
    }, []);

    const pageBg = theme === "dark" ? "dashboard-bg" : "bg-light";
    const cardBg = theme === "dark" ? "backgroundd-bg text-light" : "bg-white shadow-sm text-dark";
    const inputBg = theme === "dark" ? "" : "bg-light text-dark";
    const btnMain = theme === "dark" ? "btn btn-gradientss text-light" : "btn btn-gradientss text-light";
    const textColor = theme === "dark" ? "text-light" : "text-dark";

    useEffect(() => {
        if (!navigator.geolocation) {
            seterror("Geolocation not supported");
            return;
        }
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const lat = position.coords.latitude;
                const lon = position.coords.longitude;
                fetch(
                    `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json`,
                    {
                        headers: {
                            Accept: "application/json",
                            "User-Agent": "TravelHubApp/1.0"
                        }
                    }
                )
                    .then((res) => res.json())
                    .then((data) => {
                        const city =
                            data.address.city ||
                            data.address.town ||
                            data.address.village ||
                            data.address.state ||
                            "Unknown";
                        const country = data.address.country || "";
                        const countryCode = data.address.country_code?.toUpperCase() || "";
                        setlocation(`${city}, ${country}`);
                        localStorage.setItem("userCountry", countryCode);
                        localStorage.setItem("userCountryName", country);
                    });
                fetch(
                    `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&units=metric&appid=a22e65307679a644eec29e94b2ed88e8`
                )
                    .then((res) => res.json())
                    .then((data) => {
                        setTemp(`${Math.round(data.main.temp)}°C`);
                        setWeather(data.weather[0].main);
                        const condition = data.weather[0].main.toLowerCase();
                        if (condition.includes("clear")) setWeatherIcon("sun");
                        else if (condition.includes("cloud")) setWeatherIcon("cloud");
                        else if (condition.includes("rain")) setWeatherIcon("rain");
                        else setWeatherIcon("cloud");
                    });
            },
            () => seterror("Location permission denied")
        );
    }, []);

    return (
        <>
            <title>TravelToolkit – All-in-One Travel App | Near Me, Translator, Currency & More</title>
            <meta name="description" content="TravelToolkit is your ultimate travel companion. Find nearby places, translate languages instantly, check live currency rates, discover food apps, and access emergency services worldwide—all in one app." />
            <meta name="keywords" content="travel app, all in one travel tool, near me places app, translator app online, currency converter live, travel assistant app, emergency numbers worldwide, food apps by country, travel utilities app" />

            <meta property="og:title" content="TravelToolkit – Travel App | Location, Translator, Near Me & More" />
            <meta property="og:site_name" content="traveltoolkit" />
            <meta property="og:url" content="https://traveltoolkit.online/" />
            <meta property="og:description" content="TravelToolkit is your ultimate travel companion. Find nearby places, translate languages instantly, check live currency rates, discover food apps, and access emergency services worldwide—all in one app." />
            <meta property="og:image" content="earth.gif"></meta>

            <meta name="twitter:card" content="app" />
            <meta name="twitter:site" content="@traveltoolkit" />
            <meta name="twitter:description" content="TravelToolkit is your ultimate travel companion. Find nearby places, translate languages instantly, check live currency rates, discover food apps, and access emergency services worldwide—all in one app." />
            <meta name="twitter:app:country" content="India" />

            <div className="container-fluid p-0">
                <div className="row g-0">
                    <Sidebar />
                    <div className={`col-md-9 col-lg-10 ${pageBg} min-vh-100 p-3 offset-lg-2 offset-md-2`}>
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h1 className={`${textColor} mb-0 h4`}>Dashboard</h1>
                            <Link to="/Settings">
                                <button className={btnMain}>
                                    <IoSettingsOutline />
                                </button>
                            </Link>
                        </div>
                        <div className={`card ${cardBg} shadow mb-4`}>
                            <div className="d-flex justify-content-between align-items-center p-3">
                                <div className="d-flex gap-2 align-items-center">
                                    <button className="btn btn-gradient text-light">
                                        <FaLocationDot />
                                    </button>
                                    <div>
                                        <small>Current Location</small>
                                        <h2 className="fw-bold h6">
                                            {error ? error : location}
                                        </h2>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center gap-2">
                                    <div className="text-warning">
                                        {weatherIcon === "sun" && <FaSun />}
                                        {weatherIcon === "cloud" && <FaCloudMoon />}
                                    </div>
                                    <div>
                                        <small>{weather}</small>
                                        <h6 className="fw-bold">{temp}</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="input-group mb-4">
                            <span className={`input-group-text ${inputBg}`}>
                                <FaSearch />
                            </span>
                            <input type="text" className={`form-control ${inputBg}`} placeholder="Search for places, translate text..." value={search}
                                onChange={(e) => setsearch(e.target.value)} />
                        </div>
                        <div className="row g-4">
                            {filteredcards.length === 0 ? (
                                <div className="col-12 text-center">
                                    <p className={`${textColor} fw-bold`}>
                                        🔎 No features found
                                    </p>
                                </div>
                            ) : (
                                filteredcards.map((row, index) => (
                                    <div className="col-lg-3 col-12 col-sm-6" key={index}>
                                        <Link to={row.link} className="text-decoration-none">
                                            <div className={`card ${cardBg} feature-card h-100 p-4`}>
                                                <div className="d-flex align-items-center text-light justify-content-center iconn rounded fw-bold">
                                                    {row.icon}
                                                </div>
                                                <h6 className="mt-3">{row.name}</h6>
                                                <p className="small mb-0">
                                                    {row.desc}
                                                </p>
                                            </div>
                                        </Link>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}